import React from 'react';

import './backdrop.styles.scss';

interface IProps {
    className?: string;
    show: boolean;
    styles?: React.CSSProperties;
    children?: React.ReactNode;
    clickHandler?: (staus: boolean) => void;
}

function Backdrop({ className, show, styles, children, clickHandler }: IProps) {
    const handleClick = () => {
        if (clickHandler) clickHandler(false);
    };

    return (
        <div
            className={`backdrop  ${className || ''}  ${show ? 'show' : ''} `}
            onClick={handleClick}
            style={styles ? styles : {}}
        >
            {children}
        </div>
    );
}

export default Backdrop;
